import {
    BRINGFRIENDS_TAB_INVITATIONS,
    BRINGFRIENDS_TAB_OVERVIEW,
    BRINGFRIENDS_TAB_RULES
} from '@/bringfriends/services/tabs';
import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';
import { dispatch, useReframe } from 'nike-re-framejs';
import { bringFriendsActiveTab$ } from '@/bringfriends/subs';

function BringFriendsTabs() {
    const scrollElementRef = useHeaderTabsScroll();
    const derefSub = useReframe();
    const active = derefSub(bringFriendsActiveTab$) || BRINGFRIENDS_TAB_RULES;
    function tabChange(tab) {
        dispatch(['bringFriends.changeActiveTab', tab]);
    }
    return (
        <HeaderTabsContainer>
            <TabButton
                route={BRINGFRIENDS_TAB_RULES}
                i18nCode="jsp.bringFriends.rules.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
                onTabChange={tabChange}
            />
            <TabButton
                route={BRINGFRIENDS_TAB_INVITATIONS}
                i18nCode="jsp.bringFriends.invitations.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
                onTabChange={tabChange}
            />
            <TabButton
                route={BRINGFRIENDS_TAB_OVERVIEW}
                i18nCode="jsp.bringFriends.overview.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
                onTabChange={tabChange}
            />
        </HeaderTabsContainer>
    );
}

export default BringFriendsTabs;
